/**
 * Created by - Ashlekh on 01-04-2025
 * Reason - To create Matrimony page
 */
import { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { baseURL } from "../../Api/config";
import { getMatriMonialDetailsAPI } from "../../Api/services";
import NavigationPath from "../../components/NavigationPath/NavigationPath";
import { GlobalContext } from "../../context/Context";
import style from "./Matrimony.module.css";


const Matrimony = () => {
  const { navigationPath, setNavigationPath } = useContext(GlobalContext);
  const [matrimonialDetails, setMatriMonialDetails] = useState([]);
  const [showContent, setShowContent] = useState(false);
  const [selectedType, setSelectedType] = useState("Female");
  const [matrimonyBgImage, setMatrimonyBgImage] = useState({});
  //   Added by - Ashlekh on 03-04-2025
  //   Reason - To navigate in another page
  const navigate = useNavigate();
  // End of code - Ashlekh on 03-04-2025
  // Reason - To navigate in another page
  // Added by - Ashlekh on 02-04-2025
  // Reason - This useEffect will executes when page loads
  useEffect(() => {
    setNavigationPath([
      { name: "Home", path: "/" },
      { name: "Matrimony", path: "/matrimony" },
    ]);
    window.scrollTo(0, 0);
    getMatriMonialDetails(selectedType);
  }, []);
  // End of code - Ashlekh on 02-04-2025
  // Reason - This useEffect will executes when page loads

  const getMatriMonialDetails = async (type) => {
    try {
      const response = await getMatriMonialDetailsAPI(type);
      setMatriMonialDetails(response?.matrimonial_detail);
      setMatrimonyBgImage(response?.setting_details?.matrimony_page_background_image);
    } catch (error) {
      console.error("Error fetching details:", error);
    } finally {
      setShowContent(true);
    }
  };

  const handleViewDetails = (id) => {
    navigate(`/matrimonial-profile/${id}`, {
      state: { id },
    });
  };
  const handleDropdownChange = (e) => {
    setSelectedType(e.target.value);
    getMatriMonialDetails(e.target.value);
  };
  return (
    <div>
    {showContent ? (
      <div className={`${style.mainContainer}`}>
        {/* Added By - Yogen on 02-07-2025 
        Reason - to add for show matrimony background image */}
        {/* {(matrimonyBgImage?.length > 0) && ( */}
          <div
            className={style.matrimonyBgImage}
            style={{
              backgroundImage:
                matrimonyBgImage?.length > 0 && matrimonyBgImage
                  ? `url(${baseURL + matrimonyBgImage})`
                  : "none",
            }}
          >
            {/* End of code Addition by Yogen on 02/07/2025 
        Reason - to add for show matrimony background image */}
          <div  className={`${style.navContainer}`}><NavigationPath navigationPathArray={navigationPath} /></div>
          <div className={`${style.pageTitle}`}>Matrimony</div>
          <div className={style.dropdownContainer}>
            <label htmlFor="matrimonyType" className={style.dropdownLabel}>
              Select Type:{" "}
            </label>
            <select
              id="matrimonyType"
              value={selectedType}
              onChange={handleDropdownChange}
              className={style.dropdown}
            >
              <option value="Female">Bride</option>
              <option value="Male">Groom</option>
            </select>
          </div>
          {matrimonialDetails?.length > 0 ? (
            <table className={`${style.profileTable}`}>
              <thead>
                <tr>
                  <th className={`${style.tableHeading}`}>S No.</th>
                  <th className={`${style.tableHeading}`}>Name</th>
                  <th className={`${style.tableHeading}`}>Age</th>
                  <th className={`${style.tableHeading}`}>Gender</th>
                  <th className={`${style.tableHeading}`}>Marital Status</th>
                  <th className={`${style.tableHeading}`}>Religion</th>
                  <th className={`${style.tableHeading}`}>Profession</th>
                  <th className={`${style.tableHeading}`}>Action</th>
                </tr>
              </thead>
              <tbody>
                {matrimonialDetails?.map((item, index) => (
                  <tr key={index}>
                    <td className={`${style.tableData}`}>{index + 1}</td>
                    <td className={`${style.tableData}`}>{item.name}</td>
                    <td className={`${style.tableData}`}>{item.age}</td>
                    <td className={`${style.tableData}`}>{item.gender}</td>
                    <td className={`${style.tableData}`}>
                      {item.marital_status}
                    </td>
                    <td className={`${style.tableData}`}>{item.religion}</td>
                    <td className={`${style.tableData}`}>{item.profession}</td>
                    <td className={`${style.tableData}`}>
                      <button
                        className={`${style.viewDetailButton}`}
                        // onClick={() => handleViewDetails(item.id)}
                      >
                        <Link
                          to={"/matrimonial-profile"}
                          state={item?.id}
                          style={{ color: "white", textDecoration: "none" }}
                        >
                          View Details
                        </Link>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p className={style.noDetailsAvailableText}>No details available</p>
          )}
        </div>
        {/* )} */}
      </div>
      ) : (
        <div className={style.loaderContent}>
          <img style={{ height: "30vh" }} src="/adyant_loader.gif" />
        </div>
      )}
    </div>
  );
};
export default Matrimony;
